import React from "react";
import ReactDOM from "react-dom/client";
// import Styles from "./index.css";
import "./index.css";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
